<template>
  <div>
    <header-applis titre="Vous orienter vers le bon contact" index-progression-courante="1"/>
    <div class="wrapper__content">
      <p>Pour avancer sur votre projet professionnel, de formation, développement de compétences et cibler votre orientation, nous vous invitons tout d’abord à identifier et
        prendre contact avec l’interlocuteur adapté à votre situation.</p>
      <div class="container-flex-select">
        <button v-for="(valeur, index) in valeursPossibles" :key="index" @click="ecranSuivant(valeur)" class="button-app  big-button">
          {{ valeur }}
        </button>
      </div>
    </div>
    <footer-applis ecran-precedent="choixprojet"/>
  </div>
</template>

<script>
import FooterApplis from '../components/FooterApplis';
import HeaderApplis from '../components/HeaderApplis';

export default {
  name: 'choixstatut',
  components: {
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      valeursPossibles: [
        'Salarié de droit privé',
        'Agent public (fonctionnaires et contractuels)',
        'Personne en recherche d’emploi',
        'Dans une autre situation'
      ],
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    },
  },
  methods: {
    /**
     * Récupération du nom de l'écran suivant en fonction de la valeur sélectionnée par l'utilisateur.
     * @returns {string} Le nom de l'écran.
     */
    nomEcranSuivant(valeur) {
      if ('Salarié de droit privé' === valeur) {
        return 'salariedroitprive';
      } else if ('Personne en recherche d’emploi' === valeur) {
        return 'rechercheemploi';
      } else if ('Dans une autre situation' === valeur) {
        return 'autresituation';
      } else if ('Agent public (fonctionnaires et contractuels)' === valeur) {
        return 'agentpublic';
      }
    },
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant(valeur) {
      this.$store.commit('setSituation', valeur);
      this.$router.push(this.nomEcranSuivant(valeur));
    }
  }
}
</script>

<style scoped>

@media (min-width: 932px) {
  #appcompetences--widget .big-button.big-button.big-button.big-button {
    width: 48%;
    margin: 1%;
  }
}

</style>